import { getContext } from 'svelte';
import { ContextStateSymbol } from '../context';
export function useWalletModal() {
    const { walletModal } = getContext(ContextStateSymbol);
    return walletModal;
}
